export default __webpack_public_path__ + "static/media/bridge-screen.9bd54ba5.png";